import IChannelMessages from "interfaces/IChannelMessages";
import ILogbook from "interfaces/ILogbook";

export interface ILogbookStoreState {
  logbook?: ILogbook;
  selectedLogbookChannel?: IChannelMessages;
}

export const initialLogbookStoreState: ILogbookStoreState = {};
